<template>
  <div id="app">
    <Header :name="isHeader" :headerClickShow="headerClickShow" v-if="!isMobile"></Header>
    <MobileHeader :name="isHeader" :headerClickShow="headerClickShow" v-else></MobileHeader>
    <keep-alive>
      <router-view />
    </keep-alive>
    <img src=".\assets\btn_top.svg" class="btn_to_top" v-if="toTopFlag" @click="returnTop()">
  </div>
</template>

<script>
import Header from './components/common/header.vue'
import MobileHeader from './components/common/mobileHeader.vue'
export default {
  name: 'App',
  components: {
    Header,
    MobileHeader
  },
  data () {
    return {
      isHeader: '/home',
      nameList: ['/home', '/allapps', '/help', '/help/detail'],
      isMobile: false,
      toTopFlag: false,
      toTop: 0,
      headerClickShow: false,
      seoList: [{
        path: "/home",
        title: "One-stop application integration, shopify easy tools",
        discript: "Whether you're a total novice seller or an experienced seller with millions of dollars in turnover, we have exact solution you're looking for!",
      }]
    }
  },
  methods: {
    returnTop () {
      let distance = document.documentElement.scrollTop || document.body.scrollTop;
      let step = distance / 30; //每步的距离
      (function jump () {
        if (distance > 0) {
          distance -= step;
          window.scrollTo(0, distance)
          setTimeout(jump, 10)
        }
      })();
      // this.toTopFlag = false
    },
    handleScrollDistance () {
      // 获得当前高度
      this.toTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (this.toTop > 750) {
        this.toTopFlag = true
      } else {
        this.toTopFlag = false
      }
      if (this.toTop == 0) {
        this.headerClickShow = true
      } else {
        this.headerClickShow = false
      }
    },
    seoFunction(path) {

      let i = 0;
      this.seoList.forEach((item)=>{
        if (path === item.path) {
          // console.log(path === item.path)
          document.title = item.title;
          document.querySelector('meta[name="description"]').setAttribute("content", item.discript);
          i++;
        }
        if (i === 0) {
          // console.log(i)
          document.title = this.seoList[0].title;
          document.querySelector('meta[name="description"]').setAttribute("content", this.seoList[0].discript)
        }
      })
    }
  },
  created () {
    if (document.body.offsetWidth > 767) {
      this.isMobile = false
    } else {
      this.isMobile = true
    }
    this.isHeader = this.$route.path
    this.handleScrollDistance()
  },
  watch: {
    $route (newVal, oldVal) {
      // console.log(newVal, oldVal)
      if (this.nameList.indexOf(newVal.path) > -1) {
        this.isHeader = newVal.path
      } else {
        this.isHeader = ''
      }
      this.seoFunction(newVal.path)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScrollDistance)
    this.seoFunction(this.$route.path)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScrollDistance)
  }
}
</script>

<style>
#app {
  min-width: 1360px;
  overflow: auto;
}

html,
body,
div,
ul,
li,
h1,
h2,
h3,
h4,
h5,
h6,
p,
dl,
dt,
dd,
ol,
form,
input,
textarea,
th,
td,
select {
  margin: 0;
  padding: 0;
}
* {
  box-sizing: border-box;
  font-family: Helvetica !important;;
}
html,
body {
  height: 100%;
  width: 100%;
}

body {
  /* font-family: "Microsoft YaHei"; */
  font-size: 14px;
  background: #fff;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
}
ul,
ol {
  list-style: none;
}

img {
  border: none;
  vertical-align: middle;
}

a {
  text-decoration: none;
  color: #232323;
}

table {
  border-collapse: collapse;
  table-layout: fixed;
}

input,
textarea {
  outline: none;
  border: none;
}

textarea {
  resize: none;
  overflow: auto;
}

.title_icon {
  width: 24px;
  height: 4px;
  background: #fc5421;
  border-radius: 2px;
}
.btn_to_top {
  height: 48px;
  position: fixed;
  right: 25px;
  bottom: 160px;
  z-index: 100;
  cursor: pointer;
}

@media (min-width: 767px) {
  /* html, body {
    overflow: auto;
  } */
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  html {
    width: max-content;
    height: max-content;
  }
  /* .home_say_box {
    width: 1100px !important;
  }
  .home_say_content_item {
    width: 540px !important;
  }
  .home_say_content_item_1 {
    transform: translateX(-560px) !important;
  }
  .home_say_content_item_2 {
    transform: translateX(-1120px) !important;
  }
  .home_say_content_item_3 {
    transform: translateX(-1680px) !important;
  }
  .home_say_content_item_4 {
    transform: translateX(-2240px) !important;
  }
  .home_say_content_item_5 {
    transform: translateX(-2800px) !important;
  }
  .home_say_content_item_6 {
    transform: translateX(-3360px) !important;
  }
  .home_say_content_item_7 {
    transform: translateX(-3920px) !important;
  } */
}
@media (max-width: 767px) {
  #app {
    min-width: 320px;
  }
  .title_icon {
    width: 36px;
    height: 6px;
    background: #fc5421;
    border-radius: 3px;
  }
  /* body, html{
    
  } */
  /* .btn_to_top{
    display: none;
  } */
}
</style>



// WEBPACK FOOTER //
// src/App.vue